import ContactPageContent from './ContactPageContent';

/** Full contact details embedded on the home page (#contact). */
export default function ContactSection() {
  return (
    <section
      className="section section--contact section--contact-full"
      id="contact"
      aria-label="Contact"
    >
      <div className="contact-page contact-page--embed">
        <ContactPageContent showBackLink={false} />
      </div>
    </section>
  );
}
